import { ComponentRef, ErrorHandler, Inject, Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import {
  MmAlertContentAlign,
  MmAlertMode,
  MmAlertService,
  MmAlertSize,
  MmAlertType,
} from '@metromarkets/components';
import { BLOCKED_ACCOUNT_PAGE } from '~shared/constants';
import { HttpErrorStatuses } from '../constants/http-error-statuses.enum';
import { HttpErrorTypes } from '../constants/http-error-types.enum';
import { BadRequestHttpError, GeneralHttpError, ImsHttpError } from '../models';
import { ErrorHandlerConfig } from '../models/error-handler-config.interface';
import { ErrorHandlerConfigToken } from '../tokens/error-handler-config.token';
import { Subject } from 'rxjs';

@Injectable()
export class HttpErrorHandler implements ErrorHandler, OnDestroy {
  alertRef: ComponentRef<any>;
  private unsubscribe$ = new Subject<void>();

  constructor(
    @Inject(ErrorHandlerConfigToken)
    private readonly providedConfig: ErrorHandlerConfig,
    private router: Router,
    private alertService: MmAlertService,
  ) {}

  public handleError(
    error: GeneralHttpError | BadRequestHttpError | ImsHttpError
  ) {
    if (error instanceof GeneralHttpError) {
      const { status, type } = error;

      switch (status) {
        case HttpErrorStatuses.Forbidden:
          this.handleHttpErrorStatusForbidden(type);
          break;

        case HttpErrorStatuses.ServerError:
          this.showAlertNotification(error.title);
          break;

        default:
          break;
      }
    }
  }
  private handleHttpErrorStatusForbidden(type: string) {
    if (type === HttpErrorTypes.blocked) {
      this.handleHttpErrorBlocked();
    } else {
      this.redirectTo(this.providedConfig.forbiddenRoute);
    }
  }

  private handleHttpErrorBlocked() {
    this.router.navigateByUrl(BLOCKED_ACCOUNT_PAGE);
  }

  private redirectTo(url: string) {
    return this.router.navigate([`${url}`], {
      replaceUrl: true,
    });
  }

  private showAlertNotification(errorTitle: string, messageType: MmAlertType = MmAlertType.error): void {
    if (this.alertRef) {
      this.alertService.removeAlert(this.alertRef);
    }

    this.alertRef = this.alertService.addAlert({
      type: messageType,
      title: errorTitle,
      size: MmAlertSize.large,
      mode: MmAlertMode.banner,
      contentAlign: MmAlertContentAlign.center,
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
